let initPara = {
  sdk_url: 'https://carpool-1301582899.cos.ap-guangzhou.myqcloud.com/web-carpool/js/sensorsdata.min.js',
  heatmap_url: 'https://carpool-1301582899.cos.ap-guangzhou.myqcloud.com/web-carpool/js/heatmap.min.js',
  // sdk_url: 'https://cdn.jsdelivr.net/npm/sensors-sdk-javascript@1.14.23/sensorsdata.min.js',
  // heatmap_url: 'https://cdn.jsdelivr.net/npm/sensors-sdk-javascript@1.14.23/heatmap.min.js',
  name: 'sensors',
  server_url: 'https://sensors-datasink.wsecar.com/sa?project=' + (window.location.origin == 'https://designated.wsecar.com' ? 'production' : 'default'), // 数据接收地址
  show_log: (window.location.origin == 'https://designated.wsecar.com') ? 'production' : 'default' == 'default',// 设置 true 后会在网页控制台打 logger，会显示发送的数据,设置 false 表示不显示。默认 true。
  //配置打通 App 与 H5 的参数
  // use_app_track: true,
  heatmap: {
    //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
    clickmap: 'not_collect',
    //是否开启触达注意力图，默认 not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启
    // scroll_notice_map:'default',
    //是否开启触达注意力图，默认 not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启
    scroll_notice_map: 'not_collect',
    // scroll_delay_time: 4000,
    // scroll_event_duration: 18000 //单位秒，预置属性停留时长 event_duration 的最大值。默认5个小时，也就是300分钟，18000秒。
  },
  // is_track_single_page : () => true
};
export const sensorsInit = (para = initPara) => {
  var p = para.sdk_url,
    n = para.name,
    w = window,
    d = document,
    s = 'script',
    x = null,
    y = null;
  if (typeof (w['sensorsDataAnalytic201505']) !== 'undefined') {
    return false;
  }
  w['sensorsDataAnalytic201505'] = n;
  w[n] = w[n] || function (a) {
    return function () {
      (w[n]._q = w[n]._q || []).push([a, arguments]);
    };
  };
  var ifs = ['track', 'quick', 'register', 'registerPage', 'registerOnce', 'trackSignup', 'trackAbtest', 'setProfile', 'setOnceProfile', 'appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify', 'login', 'logout', 'trackLink', 'clearAllRegister', 'getAppStatus'];
  for (var i = 0; i < ifs.length; i++) {
    w[n][ifs[i]] = w[n].call(null, ifs[i]);
  }
  if (!w[n]._t) {
    x = d.createElement(s), y = d.getElementsByTagName(s)[0];
    x.async = 1;
    x.src = p;
    x.setAttribute('charset', 'UTF-8');
    w[n].para = para;
    y.parentNode.insertBefore(x, y);
  }
};

/**
 * @description  修改匿名 ID
 * @param {*} anonymousID 要使用的匿名 ID;
 * @param {*} isstorage 设置为 true, 会把这个 id 保存在浏览器的 cookie 中，该域名下的页面都会默认使用这个 id
 */
export const saIdentify = () => {
  let anonymousID = packct.deviceId;
  sensors.identify(anonymousID, true);
};
export const registerPage = (is_login) => {
  let saCurrentLocation = localStorage.getItem('saCurrentLocation');
  let { city = '定位失败' } = JSON.parse(saCurrentLocation || '{}');
  sensors.registerPage({
    platform_type: 'H5', // 平台类型
    app_name: '万顺叫车H5端', // 应用名称
    address: city,
    is_login, // 是否登录
  });
  if (!is_login) {
    // 未登录 修改匿名 ID
    saIdentify();
  }
};
